import { render } from "./AdminGuestsPage.vue?vue&type=template&id=68ee5db0"
import script from "./AdminGuestsPage.vue?vue&type=script&lang=js"
export * from "./AdminGuestsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__